export default __webpack_public_path__ + "9068291792db9de2238e6c2866b2cd5f.png";